/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ToolTipContentWithKeymap.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { Fragment } from 'react';
import { N400 } from '@atlaskit/theme/colors';
import { formatShortcut } from '../../util/keymaps';
var tooltipShortcutStyle = null;
export var ToolTipContentWithKeymap = /*#__PURE__*/React.memo(function (_ref) {
  var description = _ref.description,
    shortcutOverride = _ref.shortcutOverride,
    keymap = _ref.keymap;
  var shortcut = shortcutOverride || keymap && formatShortcut(keymap);
  return shortcut || description ? /*#__PURE__*/React.createElement(Fragment, null, description, shortcut && description && "\xA0", shortcut && /*#__PURE__*/React.createElement("span", {
    className: ax(["_2rkofajl _bfhk1v65 _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"]),
    style: {
      "--_1kd7x7o": ix("var(--ds-background-inverse-subtle, ".concat(N400, ")"))
    }
  }, shortcut)) : null;
});